import React from 'react'
import { Col, Row } from 'reactstrap'

const RSVSymptoms = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4'>
            <Row className=''>
                <Col sm='12' md='6' className=''>
                    <div className=''>
                        <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                            WHAT SYMPTOMS DOES THE RESPIRATORY SYNCYTIAL VIRUS PRESENT?
                        <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>
                    </div>

                    <div className='pt-2'>
                        <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        RSV typically results in a cold but can also cause pneumonia or bronchiolitis. RSV cold symptoms include:
                        </div>
                    </div>
                </Col>

                <Col sm='12' md='6' className='pt-md-4 pt-lg-0'>
                <Row  className='flex-center pt-md-0 pt-lg-0 pt-xl-0 pt-4'>
                    <Col xs='6' sm='6' md='6'  className='flex-center'>
                        <div className=''>
                            <img src='rsv-testing/RSV-Testing-icon1-v1.png' alt='' height='auto' width='90px'  />
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-18'>Coughing</div>
                        </div>
                        </Col>
                        <Col xs='6' sm='6' md='6' className='flex-center'>
                        <div className=''>
                            <img src='rsv-testing/RSV-Testing-icon2-v1.png' alt='' height='auto' width='90px'  />
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-18'>Runny Nose</div>
                        </div>
                    </Col>
                    </Row>

                    <Row className='mt-2 flex-center'>
                    <Col  xs='6' sm='6' md='6'  className='flex-center'>
                        <div className=''>
                            <img src='rsv-testing/RSV-Testing-icon3-v1.png' alt='' height='auto' width='90px'  />
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-18'>Fever</div>
                        </div>
                        </Col>

                        <Col xs='6' sm='6' md='6' className='flex-center'>
                        <div className='mt-3'>
                            <img className='flex-center' src='rsv-testing/RSV-Testing-icon4-v1.png' alt='' height='auto' width='90px'  />
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-18 lh-1-2'><center>Decreased<br/> Appetite</center></div>
                        </div>
                    </Col>
                </Row>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default RSVSymptoms